const HTML_H1_RE = /<h1[\s>/]/i;

export const expandSnippetModules = (modules, snippets) => {
    if (!Array.isArray(modules)) return [];

    return modules.flatMap((module) => {
        if (module?._type === "snippetSelector" && module.snippet?._ref) {
            const snippetData = snippets?.find((snippet) => snippet._id === module.snippet._ref);
            if (snippetData?.module?.length) {
                return expandSnippetModules(snippetData.module, snippets);
            }
        }

        return [module];
    });
};

const pageHasH1 = (value) => {
    if (value == null) return false;

    if (typeof value === "string") {
        return HTML_H1_RE.test(value);
    }

    if (Array.isArray(value)) {
        return value.some(pageHasH1);
    }

    if (typeof value === "object") {
        // Portable Text heading blocks are stored as { style: "h1" }
        if (value.style === "h1") return true;
        return Object.values(value).some(pageHasH1);
    }

    return false;
};

export default pageHasH1;
